import React, { Fragment, useState } from 'react'
import {
  Box,
  Collapse,
  IconButton,
  Typography
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Modal } from '../../../components/_EOS/Modal'
import { ModalReturnType } from '../../../hooks/useModal'
import { WorkOrderBlogComponent } from '../../../components/WorkOrderBlog/WorkOrderBlog'
import { PickingRouteComponent } from '../../../components/PickingRoute/PickingRoute'
import { OrderDetailViewer } from '../../../components/PlannerOTOutbound/OrderDetailViewer/OrderDetailViewer'
import { WorkOrderDetail } from '../../../interfaces/WorkOrderOutbound'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { Filter } from '../../../components/_WMS/FilterComponent'

interface BlogWorkOrderModalProps {
  blogWorkOrderModalState: ModalReturnType<{
    workOrderId: number
    woDetail: WorkOrderDetail[]
  }>
  handleRequestWorkOrders: (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => void
}

export const BlogWorkOrderModal: React.FC<BlogWorkOrderModalProps> = ({
  blogWorkOrderModalState,
  handleRequestWorkOrders
}) => {
  const classes = useStyles()
  const [open, setOpen] = useState<boolean>(false)

  const distinctOrders = Array.from(
    new Set(
      blogWorkOrderModalState.extendedProps?.woDetail.map(
        (x) => `${x.orderId}/${x.referenceId}`
      )
    )
  )

  const handleClose = () => {
    handleRequestWorkOrders()
    blogWorkOrderModalState.closeModal()
  }

  return (
    <Modal
      open={blogWorkOrderModalState.isOpen}
      maxWidth={blogWorkOrderModalState.size}
      onClose={handleClose}
      title={blogWorkOrderModalState.title}
      cancelButton={{
        action: handleClose,
        title: 'Salir'
      }}
    >
      <Fragment>
        <Box style={{ marginBottom: '16px' }}>
          <Typography variant='subtitle1'>
            Detalle de Rutas de Picking
          </Typography>
          <div className={classes.accordeonSummary}>
            <Typography>Rutas de Picking</Typography>
            <IconButton onClick={() => setOpen(!open)}>
              {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </div>
          <Collapse in={open} timeout='auto' unmountOnExit>
            {blogWorkOrderModalState.extendedProps ? (
              <PickingRouteComponent
                workOrderId={blogWorkOrderModalState.extendedProps.workOrderId}
              />
            ) : (
              <Typography>OT no ha sido seleccionada</Typography>
            )}
          </Collapse>
        </Box>

        <Box style={{ marginBottom: '16px' }}>
          {distinctOrders.length === 1 && (
            <Typography variant='subtitle1'>Ver detalle de pedido</Typography>
          )}
          {distinctOrders.length > 1 && (
            <Typography variant='subtitle1'>Ver detalle de pedido:</Typography>
          )}
          {blogWorkOrderModalState.extendedProps && (
            <OrderDetailViewer
              referenceList={
                blogWorkOrderModalState.extendedProps?.woDetail
                  ? distinctOrders
                  : []
              }
            />
          )}
          {!blogWorkOrderModalState.extendedProps && (
            <Typography>OT no ha sido seleccionada</Typography>
          )}
        </Box>

        <Typography variant='subtitle1'>Bitácora</Typography>
        {blogWorkOrderModalState.extendedProps && (
          <WorkOrderBlogComponent
            workOrderId={blogWorkOrderModalState.extendedProps?.workOrderId}
          />
        )}
        {!blogWorkOrderModalState.extendedProps && (
          <Typography>OT no ha sido seleccionada</Typography>
        )}
      </Fragment>
    </Modal>
  )
}

const useStyles = makeStyles(() => ({
  accordeonSummary: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, .03)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56
    },
    justifyContent: 'space-between',
    paddingLeft: '16px',
    border: '1px solid rgba(0, 0, 0, .125)',
    borderRadius: '4px',
    borderBottom: '2px solid rgba(0, 0, 0, .125)'
  }
}))
